import { isUserId, type UserRemoveBulkInput, type UserRemoveSingleInput, type UserRemoveSuccess } from '@terros/common'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useUserCache } from './cache'

export function useRemoveUser(): RemoveHookResponse<UserRemoveSingleInput> {
  const cache = useUserCache()
  const mutation = useTantalimMutation<UserRemoveSingleInput, UserRemoveSuccess>({ url: '/user/remove' })

  async function remove(input: UserRemoveSingleInput): Promise<void> {
    await mutation.mutateAsync(input)
    cache.clearList()
    if (isUserId(input.userId)) {
      cache.clearItem(input.userId)
      cache.clearProfile(input.userId)
    }
  }

  return mutationRemove(mutation, remove)
}

export function useRemoveUsers(): RemoveHookResponse<UserRemoveBulkInput> {
  const cache = useUserCache()
  const mutation = useTantalimMutation<UserRemoveBulkInput, UserRemoveSuccess>({ url: '/user/remove' })

  async function remove(input: UserRemoveBulkInput): Promise<void> {
    await mutation.mutateAsync(input)
    cache.clearList()
    input.userIds.forEach((userId) => {
      cache.clearItem(userId)
      cache.clearProfile(userId)
    })
  }

  return mutationRemove(mutation, remove)
}
